export const dataBoard = {
    projectOverview: '项目总览',
    paymentOverview: '款项总览',
    organization: '组织',
    days7: '近7天',
    days30: '近30天',
    days90: '近90天',
    days365: '近一年',
    projectStatusStatistics: '项目状态统计',
    projectSatisfactionStatistics: '项目满意度统计',
    phaseSatisfactionStatistics: '阶段满意度统计',
    quickStart: {
        title: '快速开始',
        desc: '— 完成以下操作，快速熟悉系统功能 —',
        roleTitle: '管理角色权限',
        roleDesc:
            '系统已内置了6种角色并赋予了默认项目权限，以供使用。您也可以根据实际需要进行修改和添加新的角色。',
        orgMemberTitle: '管理组织架构及成员',
        orgMemberDesc:
            '您可在「组织架构」中添加部门，并邀请组织成员加入对应部门中。',
        planTempTitle: '施工模板设置',
        planTempDesc: '您可在【施工模板】中，设置您常用的施工阶段与任务。',
        notepadTempTitle: '装修待办模板设置',
        notepadTempDesc: '您可在【装修待办模板】中设置常用的装修待办内容。',
        examineTempTitle: '巡检模板设置',
        examineTempDesc: '您可在【巡检模板】中为各施工阶段设置巡检标准。',
        inspectTempTitle: '验收模板设置',
        inspectTempDesc: '您可在【巡检模板】中为各施工阶段设置巡检标准。',
        messageTitle: '管家消息',
        messageDesc:
            '可通过【管家消息】功能，按部门、项目、角色，发送总部的管理标准',
        gotoManage: '去管理',
        gotoAdd: '去添加',
        gotoSet: '去设置',
        gotoSend: '去发送',
        close: '关闭快速开始',
    },
};
